var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14ZM24.4 14C24.4 19.7438 19.7438 24.4 14 24.4C8.25624 24.4 3.6 19.7438 3.6 14C3.6 8.25624 8.25624 3.6 14 3.6C19.7438 3.6 24.4 8.25624 24.4 14ZM13.5 8C13.9418 8 14.3 8.35817 14.3 8.8V13.5496L18.9886 17.1666C19.3385 17.4364 19.4033 17.9388 19.1334 18.2886C18.8636 18.6385 18.3612 18.7033 18.0114 18.4334L13.0425 14.6003C12.8265 14.4337 12.7 14.1763 12.7 13.9035V8.8C12.7 8.35817 13.0582 8 13.5 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.fc855d9544b258faa87289d38198c435.svg";
export { ForwardRef as ReactComponent };